//  基础接口配置地址
// export let baseAPI =  window.location.protocol + "//" + window.location.host

/*
export let baseAPI = 'https://formflow.supwisdom.com'

// 文件服务器接口地址
export let fileBaseAPI =  "https://formflow.supwisdom.com/fileService1"
*/

const config = {
  // FIXME:测试使用token
  // token: localStorage.getItem('Admin-Token'),
  token:
    'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJzbWFydGFkbWluIiwiaXNzIjoiY2FzLmRldjIuc3Vwd2lzZG9tLmNvbSIsIkFUVFJfaWRlbnRpdHlUeXBlSWQiOiIxIiwiQVRUUl9hY2NvdW50SWQiOiIxIiwiQVRUUl91c2VySWQiOiIxIiwiQVRUUl9uYW1lIjoi5pm65oWn5qCh5Zut566h55CG5ZGYIiwiQVRUUl9pZGVudGl0eVR5cGVDb2RlIjoiYWRtaW4iLCJBVFRSX2lkZW50aXR5VHlwZU5hbWUiOiLnrqHnkIYiLCJBVFRSX2FjY291bnROYW1lIjoic21hcnRhZG1pbiIsIkFUVFJfb3JnYW5pemF0aW9uTmFtZSI6IuaZuuaFp-Wkp-WtpiIsIkFUVFJfdXNlck5hbWUiOiLmmbrmhafmoKHlm63nrqHnkIblkZgiLCJleHAiOjE2NzcyOTE4MjMsIkFUVFJfb3JnYW5pemF0aW9uSWQiOiIxIiwiaWF0IjoxNjc3MTE5MDIzLCJqdGkiOiJJRC1Ub2tlbi03MTIzLUJqa0JGUlpnSlpyU1kyM0hpaXRxZ21tMk4tenhKeXBmIiwicmVxIjoiLSIsIkFUVFJfb3JnYW5pemF0aW9uQ29kZSI6IjEifQ.mxrQzAVhJ738Dn1xe1H4F3j1ojJrO_7dBwmxy5r4x7R4__SRj4t-urArXk9IFdqjZ25yNXuLFJosnUhyyHdcRl0vUmSjBOr1OwcoIzYkgGw4YIUVEg7PDzxRSTgFB_KgAeTbSTEVYqS86cQHPr4prwqneYcbb-ExNzP4zY0uPzX6lZ2k85kOIMQ9r1b3jGlZxqK3_DazBr0GM2-BZvcW8mkyPUc_BpoE9UcxCN0U1OQ4i4jpHg-EVAIje5tMRAJvLnYCTS-zeoXqXPopwnwA8sSPwzTTLxHoaepnI0INiWdxei3-rY2cfAGKEf2TPlobBeWFM3NbWhVPit03MLy0nA',
  baseAPI: process.env.VUE_APP_BASE_API, //  基础接口配置地址
  // baseAPI: 'http://192.168.94.82:10081', //  基础接口配置地址
  oneTableWareAPI: process.env.VUE_APP_ONE_TABLE_WARE,
  smartReportAPI: process.env.VUE_APP_SMART_REPORT_API,

  fileBaseAPI: 'https://formflow.dev2.supwisdom.com/fileService', // 文件服务器接口地址
  previewBaseApi: process.env.VUE_APP_FORM_FILE_PREVIEW, // 文件在线预览
  pageType: 'preview', // design为设计页，write为发起流程页,handle为审批流程页
  // 发起页参数
  fid: '66fd4bf9-5800-4194-a187-bdeb9cfe5d70',
  deployId: 'c44a09663ae64076855fe5d29ec9ed4f',
  // 审批页参数
  ffid: '2a8577b498f94e1585724d7bcb27261c',
  taskId: 'a91e6fd0002646f58a71801ccb9b3480',
  // 设计页参数
  // id: '5ad37e73652e4feda24eddec7cf64bec',
  id: '4e8b6fc4-d52e-495f-b400-143441969a0d',
  version: '8',
}
export { config }
